export default __webpack_public_path__ + "static/media/paid_img.dc28cee0.png";